import { convertFromRaw, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

export const convertPlaintextToRawFormat = (plaintext) => {
    return JSON.stringify(convertToRaw(plaintext));
}

export const convertRawToPlaintext = (raw) => {
    if(isDraftRawFormat(raw)) {
        return draftToHtml(JSON.parse(raw))
    }
    return raw;
}

export const convertToEditorFormat=(content)=>{
    return convertFromRaw(JSON.parse(content));
}

export const isDraftRawFormat = (value) => {
    if (!value) return false;

    // JSONB case
    if (typeof value === 'object') {
        return Array.isArray(value.blocks) && value.entityMap !== undefined;
    }

    // TEXT case
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed.blocks) && parsed.entityMap !== undefined;
        } catch {
            return false;
        }
    }

    return false;
}